<div *ngIf="isVisible" class="bottom-first-level-container" [ngStyle]="{'height.px' : panelHeight}" #vehicleTable>
    <div class="vehicle-list-full-container">

        <tk-vehicle-list-full-expand></tk-vehicle-list-full-expand>

        <div class="vehicle-list-full-header">
            <div class="vehicle-list-full-filter">
                <tk-vehicle-list-filter [mode]="'full'" [additionalParams]="additionalParams"
                    (onFilterChanged)="onFilterChanged($event)"></tk-vehicle-list-filter>
            </div>

            <div class="action-container">
                <div class="btn-configure-table" (click)="configureTable()"></div>
                <div class="btn-open-vehicle-list-lite" (click)="switchToVehicleListLite()"
                    title="{{'vehicles-list.list-view-mode' | translate}}"></div>
                <div class="btn-close" [routerLink]="['/panel' , 'main']"></div>
            </div>
        </div>

        <div *ngIf="!vehicles" class="loading-vehicles">{{'labels.loading-data' | translate}}</div>

        <div *ngIf="vehicles && vehicles.length >= 0 " class="loaded-vehicles loaded-vehicles-full-list"
            (scroll)="onScroll($event)">
            <div class="vehicle-table">

                <div class="header" [ngStyle]="{'min-width.px' : minWidth}" *ngIf="config">
                    <ng-container *ngFor="let type of config.VehicleFullListColumnsOrder">

                        <!-- { Type: 13, Name: 'Status' }, -->
                        <!-- dane z czujnika -->
                        <div class="header-column status" *ngIf="showColumn(13) && type === 13">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(13)">
                                    <span>{{'labels.status' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(13)}}</span>
                                </a>
                            </div>
                        </div>

                        <!-- { Type: 2, Name: 'Czas' }, -->
                        <!-- czas od ostatniej aktualizacji czujnika -->
                        <div class="header-column time" *ngIf="showColumn(2) && type === 2">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(2)">
                                    <span>{{'labels.time' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(2,'min-max')}}</span>
                                </a>
                            </div>
                        </div>

                        <!-- { Type: 11, Name: 'Pojazd' }, -->
                        <!-- nazwa samocodu -->
                        <div class="header-column name" *ngIf="showColumn(11) && type === 11">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(11)">
                                    <span>{{'labels.vehicle' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(11)}}</span>
                                </a>
                            </div>
                        </div>

                        <!-- { Type: 12, Name: 'Prędkość' }, -->
                        <div class="header-column speed" *ngIf="showColumn(12) && type === 12">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(12)">
                                  <span>{{'labels.speed' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(12,'number')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 1, Name: 'Adres' }, -->
                        <div class="header-column location" *ngIf="showColumn(1) && type === 1">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(1)">
                                  <span>{{'labels.address' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(1)}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 4, Name: 'Kierowca' }, -->
                        <div class="header-column driver" *ngIf="showColumn(4) && type === 4">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(4)">
                                  <span>{{'labels.driver' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(4)}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 19, Name: 'eToll' }, -->
                        <div class="header-column etoll" *ngIf="showColumn(19) && type === 19">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(19)">
                                  <span>{{'labels.etoll' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(19)}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 14, Name: 'Sygnał GPS' }, -->
                        <div class="header-column gps" *ngIf="showColumn(14) && type === 14">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(14)">
                                  <span>{{'labels.gps' | translate}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(14,'min-max')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 15, Name: 'Sygnał GSM' }, -->
                        <div class="header-column gsm" *ngIf="showColumn(15) && type === 15">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(15)">
                                  <span>{{'labels.gsm' | translate}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(15,'min-max')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 8, Name: 'Paliwo' }, -->
                        <div class="header-column fuel" *ngIf="showColumn(8) && type === 8">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(8)">
                                  <span>{{'labels.fuel' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(8,'number')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 7, Name: 'Obroty' }, -->
                        <div class="header-column rpm" *ngIf="showColumn(7) && type === 7">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(7)">
                                  <span>{{'labels.rpm' | translate}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(7,'number')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 17, Name: 'Temperatura' }, -->
                        <div class="header-column temperature" *ngIf="showColumn(17) && type === 17">
                            <div class="header-column-content">
                                <span>{{temperatureUnit}}</span>
                            </div>
                        </div>

                        <!-- { Type: 3, Name: 'Czujniki' }, -->
                        <div class="header-column indicators" *ngIf="showColumn(3) && type === 3">
                            <div class="header-column-content">
                                <tk-vehicle-list-full-inidicator-status-header
                                    (onStatusChanged)="onIndicatorStatusFilterChanged($event)"
                                    [currentValue]="additionalParams.BinaryParamState">
                                </tk-vehicle-list-full-inidicator-status-header>
                                <span class="label" title="{{indicatorColumnTitle}}">{{indicatorColumnTitle}}</span>
                                <tk-vehicle-list-full-inidicator-value-header
                                    (onValueChanged)="onIndicatorValueFilterChanged($event)"
                                    [currentValue]="additionalParams.BinaryParamName">
                                </tk-vehicle-list-full-inidicator-value-header>


                                <!-- przelacznik widzialnosci -->
                                <tk-vehicle-list-full-indicator-column-full
                                    [isIndictorColumnFullOn]="isIndictorColumnFullOn"
                                    (onSwitchChange)="onIndictorColumnFullChange($event)">
                                </tk-vehicle-list-full-indicator-column-full>
                            </div>
                        </div>

                        <!-- { Type: 16, Name: 'Tachograf' }, -->
                        <ng-container *ngIf="showColumn(16) && type === 16">
                            <div class="header-column-block-container">
                                <div class="header-column header-column-block tacho" *ngIf="showTachoColumn()">
                                    <div class="header-column-content">
                                        <span class="label">{{'labels.tacho' | translate | titlecase}}</span>
                                    </div>

                                </div>
                                <tk-vehicle-list-full-tacho-header (onValueChanged)="onTachoValueFilterChanged($event)">
                                </tk-vehicle-list-full-tacho-header>

                                <div class="header-column header-column-block tacho" *ngIf="showTachoColumn('driving')">
                                    <div class="header-column-content">
                                        <span class="label">{{'labels.driving' | translate | titlecase}}</span>
                                    </div>

                                </div>
                                <div class="header-column header-column-block tacho" *ngIf="showTachoColumn('working')">
                                    <div class="header-column-content">
                                        <span class="label">{{'labels.work' | translate | titlecase}}</span>
                                    </div>
                                </div>

                                <div class="header-column header-column-block tacho" *ngIf="showTachoColumn('resting')">
                                    <div class="header-column-content">
                                        <span class="label">{{'vehicles-list.rest-short' | translate}}</span>
                                    </div>

                                </div>
                                <div class="header-column header-column-block tacho" *ngIf="showTachoColumn('free')">
                                    <div class="header-column-content">
                                        <span class="label">{{'vehicles-list.disposable-short' | translate}}</span>
                                    </div>

                                </div>
                            </div>

                        </ng-container>

                        <!-- { Type: 5, Name: 'Licznik km' }, -->
                        <div class="header-column km-counter" *ngIf="showColumn(5) && type === 5">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(5)">
                                  <span>
                                    {{'vehicle-indicator.counter' | translate}} {{'measure-unit.kilometers-short' | translate}}
                                  </span>
                                    <span class="sort-dir">{{getSortColumnDir(5,'number')}}</span></a>
                            </div>

                        </div>

                        <!-- { Type: 6, Name: 'Napięcie' }, -->
                        <div class="header-column power" *ngIf="showColumn(6) && type === 6">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(6)">
                                  <span>{{'vehicle-indicator.voltage' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(6,'number')}}</span></a>
                            </div>
                        </div>

                        <!-- { Type: 9, Name: 'Paliwo CAN' },
                        <div class="header-column can-fuel" *ngIf="showColumn(9) && type === 9">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(9)"><span>Paliwo CAN</span>
                                    <span class="sort-dir">{{getSortColumnDir(9,'number')}}</span></a>
                            </div>
                        </div>
                        -->

                        <!-- { Type: 10, Name: 'Pedał gazu' }, -->
                        <div class="header-column accelerator" *ngIf="showColumn(10) && type === 10">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(10)">
                                  <span>{{'vehicle-indicator.gas-pedal' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(10,'number')}}</span></a>
                            </div>
                        </div>

                        <!-- { Type: 18, Name: 'Zuzycie CAN' }, -->
                        <div class="header-column can-fual-usage" *ngIf="showColumn(18) && type === 18">
                            <div class="header-column-content">
                                <a class="column-name-with-sort" (click)="setSortColumn(18)">
                                  <span>{{'vehicle-indicator.usage-can' | translate | titlecase}}</span>
                                    <span class="sort-dir">{{getSortColumnDir(18,'number')}}</span></a>
                            </div>
                        </div>

                    </ng-container>

                </div>

                <!-- brak wyniku -->
                <ng-container *ngIf="vehicles && vehicles.length === 0 && currentFilter">
                    <div class="no-vehicles">
                        <span class="msg-main">{{'labels.no-result' | translate}}</span>
                    </div>
                </ng-container>

                <!-- wynik -->
                <ng-container *ngIf="vehicles && vehicles.length > 0">
                    <div class="items" [ngStyle]="{'min-width.px' : minWidth}">

                        <tk-scrolled-list id="vehicle-full-list" [itemHeight]="32" [items]="vehicles"
                            [selectedId]="selectedVehicleId" idFieldName="Id" sortFieldName="$index"
                            [areaHeight]="areaHeight">
                            <ng-template #itemTemplate let-item let-idx="idx">
                                <div (click)="onSelect(item)" [class.selected]="item.Id === selectedVehicleId">
                                    <tk-vehicle-list-full-item [vehicle]="item" [config]="config" [options]="options"
                                        [isSelected]="item.Id === selectedVehicleId" [index]="idx"
                                        (onVehicleUpdate)="onVehicleUpdate($event)" [isScrolling]="isScrolling"
                                        [isIndictorColumnFullOn]="isIndictorColumnFullOn"
                                        (onItemDataChange)="onItemDataChange($event)"
                                        [indictorColumnFullMinWidth]="indictorColumnFullLength"
                                        [indictorColumnFullLeft]="indictorColumnFullLeft">
                                    </tk-vehicle-list-full-item>
                                </div>

                            </ng-template>
                        </tk-scrolled-list>

                    </div>
                </ng-container>

            </div>
            <!-- komponent scroll bar
            <div class="loaded-vehicles-full-list-scroll-bar">
                <tk-scroll-bar elementId="vehicle-full-list"></tk-scroll-bar>
            </div>
           -->
        </div>

        <!-- config -->
        <tk-vehicle-list-config *ngIf="isConfigVisible" (onClose)="onConfigureTableClose($event)">
        </tk-vehicle-list-config>

    </div>
</div>
